import React from 'react';

const NextSwiperArrow= () => {
  return (
    <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              height="32"
              width="32"
              aria-hidden="true"
              fill="currentcolor"
              role="img"
              focusable="false"
              className="Svg-sc-12lgb6u-0 kRLFlm ChevronRight__SvgChevronRight-sc-ec4b4o-0 ktEMtW"
            >
              <path d="M8 16.6l4.6-4.6L8 7.4 9.4 6l6 6-6 6L8 16.6z"></path>
            </svg>
  );
};



export default NextSwiperArrow;
